import Axios from 'src/utils/axiosConfig';
import {
  LOADING_ORDER_SALES_REPOORT,
  SET_ORDER_SALES_REPOORT,
  ORDER_SALES_REPORT_ERROR,
} from './reports.type';

const getOrderSalesReport = () => async (dispatch) => {
  dispatch({ type: LOADING_ORDER_SALES_REPOORT, value: true });

  try {
    const result = await Axios.get('reports/sales/all');
    dispatch({ type: LOADING_ORDER_SALES_REPOORT, value: false });
    dispatch({ type: SET_ORDER_SALES_REPOORT, report: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_ORDER_SALES_REPOORT, value: false });
    dispatch({ type: ORDER_SALES_REPORT_ERROR, error: error.message });
  }
};

export {
  getOrderSalesReport,
};
